import { MobileSkeletonLoader } from '@/components/atoms/MobileSkeletonLoader/MobileSkeletonLoader'
import { MobileBlockHeader } from '@/components/molecules/MobileBlockHeader/MobileBlockHeader'
import { CardsPreview } from '@/features/Cards/ui/CardsPreview/CardsPreview'
import { BalancesMapper } from '@/features/Wallets/wallet.mapper'
import { AppRoutes } from '@/routes'
import { getUrl } from '@/shared/helpers/url'
import { createCardsQueryOptions } from '@/features/Cards/queries'
import { useBalancesStore } from '@/store'
import { Flex } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createBalancesQueryOptions } from '@/features/Wallets/queries'
import { Asset } from '@/components/organisms/Asset/Asset'
import { useRouter } from 'nextjs-toploader/app'

type Props = {
  withHeader?: boolean;
}

export function Assets({ withHeader }: Props) {
  const { data: cards } = useQuery(createCardsQueryOptions())
  const { data: balances, isPending } = useSuspenseQuery(createBalancesQueryOptions())
  const selectedWallet = useBalancesStore((state) => state.selectedWallet)
  const router = useRouter()

  const data = useMemo(() => BalancesMapper.filterBalancesByAddressWithCards(balances, cards, selectedWallet?.address), [balances, cards, selectedWallet])

  const handleNavigate = useCallback((address: string) => {
    const url = getUrl(AppRoutes.ASSET_DETAILS_PAGE, { id: address })
    router.push(url)
  }, [router])

  if (isPending || !selectedWallet || !data) {
    return <MobileSkeletonLoader withTitle height="70px" width="100%" amount={3} />
  }

  return (
    <div>
      {withHeader && <MobileBlockHeader title="Assets" viewAllTitle={data.tokens.length > 3 && 'View all'} />}

      <Flex key={data.address} vertical gap={12}>
        {data.tokens.map((token) => (
          <Asset
            key={token.address}
            onClick={() => handleNavigate(token.address)}
            token={token}
            extra={<Flex gap={5}><CardsPreview cards={token.cards} /></Flex>}
          />
        ))}
      </Flex>
    </div>
  )
}
